export default {
  SHOW_LOADING: "SHOW_LOADING",
  HIDE_LOADING: "HIDE_LOADING",
  SHOW_NOTIFICATION: "SHOW_NOTIFICATION",
  HIDE_NOTIFICATION: "HIDE_NOTIFICATION",
  SET_PAGE_INFO: "SET_PAGE_INFO",
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
  SAVE_EVENTS_MASTER_DATA: "SAVE_EVENTS_MASTER_DATA",
};
